import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

// This is a very non-fancy error message, used in various admin-like places.
// We should probably improve the design for this.
export default function ErrorMessage({ message, timeout }) {
  const [open, setOpen] = useState(true)
  useEffect(() => {
    let timer
    if (timeout) {
      timer = setTimeout(() => setOpen(false), timeout)
    }

    return () => clearTimeout(timer)
  })

  return (
    open && (
      <div
        className={`status-message alert alert-${message.type}`}
        role="alert">
        <button
          type="button"
          className="close"
          aria-label="Close"
          onClick={() => setOpen(false)}>
          <span aria-hidden="true">&times;</span>
        </button>
        {message.html}
      </div>
    )
  )
}

ErrorMessage.propTypes = {
  message: PropTypes.shape({
    html: PropTypes.node,
    type: PropTypes.string,
  }),
  timeout: PropTypes.number,
}
